import _ from 'lodash';
import { preload } from 'react-isomorphic-render';
import { connect } from 'react-redux';
import fetchMarketingPage from 'app/api/marketing-api';
import { baseMapStateToProps, baseMapDispatchToProps, basePreload } from 'app/common/containers/base';
import App from 'app/components/root-apps/marketing-app';

const mapStateToProps = (state, ownProps) => ({
  ...baseMapStateToProps(state, ownProps),
  ..._.get(state, 'marketing.marketingPage'),
});

const MarketingContainer = connect(mapStateToProps, baseMapDispatchToProps)(preload(
  ({ dispatch, getState, parameters }) => Promise.all(
    [dispatch(fetchMarketingPage(parameters.slug))].concat(basePreload(dispatch, getState()))),
)(App));

export default MarketingContainer;



// WEBPACK FOOTER //
// ./app/containers/root-apps/marketing-app.js